/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const order_payout_bank_details_description_refund = () => `Ihre Rückerstattung konnte nicht auf Ihr ursprüngliches Konto überwiesen werden. Geben Sie Ihre Bankdaten ein, damit wir sie überweisen können.`
